import { Commons } from "../../helper/CommonService";
import { Navigate } from "react-router-dom";

function AdminChecker({ children }) {
    if (!Commons.IsAdmin()) {
        return <Navigate to="/loginAdmin" />;
    }
    return children;
}

export default AdminChecker;